import { useModuleContext } from '../../contexts/EventsContext'
import usePush from '../../hooks/usePush'
import { Dropdown } from '@mch-group/uikit-components'

// Access Filter usually titled in screen as "Type"
const HosttypeFilter = () => {
  //@ts-ignore
  const [{ filters, router, labels }] = useModuleContext()
  const { pushChange } = usePush()
  const routerQuery = router.query

  const translatedOptions = Object.freeze({
    ART_BASEL: labels.Events.browseFilterHostTypeArtBasel,
    GALLERY: labels.Events.browseFilterHostTypeGallery,
    SPONSOR: labels.Events.browseFilterHostTypeSponsor,
    CULTURAL_INSTITUTION: labels.Events.browseFilterHostTypeCulturalInstitution
  })

  const optionsConnectedToLabels = filters
    .find((filter) => filter.entityType === 'HOST_TYPE').options.map((filter) => {
      const filterCopy = { ...filter }
      filterCopy.value = filterCopy.code
      filterCopy.label = translatedOptions[filterCopy.code]
      filterCopy.disabled = filter.count === 0
      return filterCopy
    })

  return (
    <Dropdown
      className='mb-9 mb-md-10 mb-lg-0 mb-xl-0 mb-xxl-0'
      label={labels.Events.browseFilterAll}
      variant='multiple'
      options={optionsConnectedToLabels}
      isMultiselect
      onChange={(value) => {
        const currentSelection = routerQuery.hostType ? routerQuery.hostType.split(',') : []
        const isCurrentSelectionAlreadySelected = currentSelection.find((option) =>
          // @ts-ignore
          value.join() === option)
        const filteredAry = isCurrentSelectionAlreadySelected ?
          // @ts-ignore
          currentSelection.filter(e => e !== value.join())
          : value
        pushChange(filteredAry.join(), 'hostType')
      }}
      value={[...routerQuery?.hostType?.split(',') || []]}
      onVisibilityChange={() => { }}
    />
  )
}

export default HosttypeFilter
